// Beep generato via Web Audio API: nessun file esterno, funziona offline.
let ctx = null;
let sbloccato = false;

function getCtx() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  return ctx;
}

// I browser bloccano l'audio finche' l'utente non interagisce con la pagina.
export function sbloccaAudio() {
  if (sbloccato) return;
  const c = getCtx();
  if (!c) return;
  if (c.state === 'suspended') c.resume().catch(() => {});
  sbloccato = true;
}

export function suonaAvviso() {
  if (localStorage.getItem('promemoria_muto') === '1') return;
  const c = getCtx();
  if (!c) return;
  if (c.state === 'suspended') { c.resume().catch(() => {}); }

  // due note brevi, discrete
  [[880, 0], [1174, 0.18]].forEach(([freq, delay]) => {
    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.type = 'sine';
    osc.frequency.value = freq;
    const t0 = c.currentTime + delay;
    gain.gain.setValueAtTime(0, t0);
    gain.gain.linearRampToValueAtTime(0.18, t0 + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.001, t0 + 0.16);
    osc.connect(gain).connect(c.destination);
    osc.start(t0);
    osc.stop(t0 + 0.18);
  });
}

export function isMuto() {
  return localStorage.getItem('promemoria_muto') === '1';
}

export function setMuto(v) {
  localStorage.setItem('promemoria_muto', v ? '1' : '0');
}
